var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAutoGooglePost(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.73779 6.25747C4.15213 3.44195 7.03399 1.66535 10.1848 1.66656C11.2526 1.65415 12.3014 1.85528 13.2739 2.24754L10.4999 4.98668C10.3953 4.98111 10.2902 4.97918 10.1848 4.98096C8.05447 5.00746 6.17839 6.38976 5.52189 8.41656L2.73779 6.25747Z",
    fill: "white",
    fillOpacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.73793 6.25781C1.55611 8.6128 1.55611 11.3877 2.73793 13.7427L5.52199 11.5836C5.17356 10.5568 5.17356 9.44371 5.52199 8.41691L2.73793 6.25781Z",
    fill: "white",
    fillOpacity: 0.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0068 14.2242C10.6701 15.724 7.55997 15.0456 6.06013 12.7089C5.83471 12.3578 5.65389 11.9799 5.52185 11.584L2.73779 13.7431C4.15211 16.5586 7.03398 18.3352 10.1848 18.334C12.2134 18.389 14.1863 17.6668 15.6999 16.3151L13.0068 14.2242Z",
    fill: "white",
    fillOpacity: 0.6
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9284 2.23751L18.4284 4.73751C18.5065 4.81498 18.5685 4.90715 18.6108 5.0087C18.6531 5.11025 18.6749 5.21917 18.6749 5.32918C18.6749 5.43919 18.6531 5.54811 18.6108 5.64966C18.5685 5.75121 18.5065 5.84338 18.4284 5.92084C18.3509 5.99895 18.2588 6.06095 18.1572 6.10325C18.0557 6.14556 17.9468 6.16734 17.8367 6.16734C17.7267 6.16734 17.6178 6.14556 17.5163 6.10325C17.4147 6.06095 17.3225 5.99895 17.2451 5.92084L16.1701 4.83751V9.49584C16.1701 9.71686 16.0823 9.92882 15.926 10.0851C15.7697 10.2414 15.5578 10.3292 15.3367 10.3292C15.1157 10.3292 14.9038 10.2414 14.7475 10.0851C14.5912 9.92882 14.5034 9.71686 14.5034 9.49584V4.83751L13.4284 5.92084C13.2715 6.07776 13.0587 6.16592 12.8367 6.16592C12.6148 6.16592 12.402 6.07776 12.2451 5.92084C12.0882 5.76393 12 5.5511 12 5.32918C12 5.10726 12.0882 4.89443 12.2451 4.73751L14.7451 2.23751C14.8243 2.16164 14.9178 2.10217 15.0201 2.06251C15.223 1.97916 15.4505 1.97916 15.6534 2.06251C15.7557 2.10217 15.8492 2.16164 15.9284 2.23751Z",
    fill: "white",
    fillOpacity: 0.6
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0401 8.48438H10.1851V11.7078H14.6699C14.4824 12.7382 13.8816 13.6469 13.007 14.223L15.7001 16.314C17.3587 14.7165 18.2618 12.4904 18.185 10.1889C18.1855 9.61734 18.1348 9.04692 18.0335 8.48438H16.6251V9.49537C16.6251 10.1409 16.2731 10.8743 15.337 10.8743C14.4009 10.8743 14.0401 10.1262 14.0401 9.49537V8.48438Z",
    fill: "white",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutoGooglePost);
export default __webpack_public_path__ + "static/media/AutoGooglePost.aa44a017.svg";
export { ForwardRef as ReactComponent };